module.exports = __webpack_public_path__ + "img/luggage.1d3d003b.svg";